<script setup lang="ts">
  import type { Editor } from '@tiptap/vue-3';
  import { ref } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import TextEditor from './TextEditor.vue';
  import TextEditorToolbar from './TextEditorToolbar.vue';

  const props = withDefaults(
    defineProps<{
      placeholderText?: string;
      showToolbar?: boolean;
      minHeightClass?: string;
      resizable?: boolean;
      error?: boolean;
      markdown?: boolean;
      class?: HTMLAttributes['class'];
    }>(),
    {
      showToolbar: true,
      minHeightClass: 'min-h-32',
      resizable: true,
      error: false,
      markdown: true,
    },
  );

  const emit = defineEmits<{
    (e: 'ready', editor: Editor): void;
  }>();

  const body = defineModel<string>();
  const editor = ref<Editor | null>(null);

  const onReady = (e: Editor) => {
    editor.value = e;
    emit('ready', e);
  };
</script>

<template>
  <div
    :class="
      cn(
        'flex flex-col rounded-sm border bg-background',
        error ? 'border-destructive' : 'border-border',
        minHeightClass,
        resizable && 'max-h-[60vh] resize-y overflow-auto',
        props.class,
      )
    "
  >
    <TextEditorToolbar
      v-if="showToolbar"
      :editor="editor as any"
      :class="
        cn(
          'shrink-0 border-b border-border px-1 py-1',
          resizable && 'sticky top-0 z-10 bg-background',
        )
      "
    />
    <TextEditor
      v-model="body"
      class="flex-1 p-4"
      :markdown="markdown"
      :placeholder-text="placeholderText"
      @ready="onReady"
    />
  </div>
</template>
